<template>
  <div>
    <Header :isRetroPage="true" :isOldRetroPage="true" :retro="{
      retroName:retro.retroName,
      createdDate:retro.createdDate
    }" :saveRetroTitle="saveRetroTitle"  />
    <div class="center columns">
      <div class="column">
        <div class="subtitle">What went well?</div>
        <div class="newPointWrapper">
          <input tabindex="-1" type="text" placeholder="Write something..." v-model="newWentWellPoint" @keyup.enter="addTalkingPoint('wentWell', 'newWentWellPoint')" />
          <button v-if="newWentWellPoint.length" @click="addTalkingPoint('wentWell', 'newWentWellPoint')"></button>
        </div>
        <div class="existedPointAll">
          <div class="existedPoint" v-for="wentWellOne in wentWell" :key="wentWellOne.id">
            <pre v-html="wentWellOne.title"></pre>
            <textarea
              tabindex="-1"
              @blur="pointOnBlur('wentWell', wentWellOne.title, wentWellOne.id, $event)"
              @keydown.esc.prevent="pointOnBlur('wentWell', wentWellOne.title, wentWellOne.id, $event)"
              @keydown.enter.prevent="pointOnBlur('wentWell', wentWellOne.title, wentWellOne.id, $event)"
              v-model="wentWellOne.title"
            ></textarea>
            <button
                    v-bind:class="{ voted: checkIsVoted('wentWell', wentWellOne.id) }"
                    @click="voteClick('wentWell', wentWellOne.id)">
              + {{ wentWellOne.rate }}</button>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="subtitle">What can we improve?</div>
        <div class="newPointWrapper">
          <input tabindex="-1" type="text" placeholder="Write something..." v-model="newToImprovePoint" @keyup.enter="addTalkingPoint('toImprove', 'newToImprovePoint')" />
          <button v-if="newToImprovePoint.length" @click="addTalkingPoint('toImprove', 'newToImprovePoint')"></button>
        </div>
        <div v-for="toImproveOne in toImprove" :key="toImproveOne.id">
          <div class="existedPoint">
            <pre v-html="toImproveOne.title"></pre>
            <textarea
              tabindex="-1"
              @blur="pointOnBlur('toImprove', toImproveOne.title, toImproveOne.id, $event)"
              @keydown.esc.prevent="pointOnBlur('toImprove', toImproveOne.title, toImproveOne.id, $event)"
              @keydown.enter.prevent="pointOnBlur('toImprove', toImproveOne.title, toImproveOne.id, $event)"
              v-model="toImproveOne.title"
            ></textarea>
            <button
              v-bind:class="{
                voted: checkIsVoted('toImprove', toImproveOne.id)
              }"
              @click="voteClick('toImprove', toImproveOne.id)"
            >
              + {{ toImproveOne.rate }}
            </button>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="subtitle">Action items</div>
        <div class="newPointWrapper">
          <input tabindex="-1" type="text" placeholder="Write something..." v-model="newActionPoint" @keyup.enter="addTalkingPoint('actionItems', 'newActionPoint')" />
          <button v-if="newActionPoint.length" @click="addTalkingPoint('actionItems', 'newActionPoint')"></button>
        </div>
        <div v-for="actionItem in actionItems" :key="actionItem.id">
          <div class="existedPoint existedPoint_noVotes">
            <pre v-html="actionItem.title"></pre>
            <textarea
              tabindex="-1"
              @blur="pointOnBlur('actionItems', actionItem.title, actionItem.id, $event)"
              @keydown.esc.prevent="pointOnBlur('actionItems', actionItem.title, actionItem.id, $event)"
              @keydown.enter.prevent="pointOnBlur('actionItems', actionItem.title, actionItem.id, $event)"
              v-model="actionItem.title"
            ></textarea>
          </div>
        </div>
      </div>
    </div>

    <div class="prompt" v-if="showPrompt">
      <button class="prompt_close" @click="closePrompt"></button>
      <div class="prompt_title">Upgrade your team</div>
      <div class="prompt_text">Private retros, mention teammates, admin controls, and more...</div>
      <router-link v-bind:to="'/signup'">
        Create workspace
      </router-link>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import db,{ ANALYTICS } from 'src/firebase-config';
import Header from '../elements/Header';
import { mapState } from 'vuex';

const retrosCollection = db.collection('retros');

export default {
  components: { Header },
  props: {},
  data() {
    return {
      retro: {
        retroName: ' '
      },
      retroID: this.$router.currentRoute.path.substr(1),
      wentWell: [],
      toImprove: [],
      showPrompt: true,
      actionItems: [],
      newWentWellPoint: '',
      newToImprovePoint: '',
      newActionPoint: '',
      fullUrl: window.location.href,
      copyButtonText: 'Copy Link',
      copyButtonActiveClass: '',
      voted: {
        wentWell: [],
        toImprove: []
      }
    };
  },
  computed: {
    ...mapState(['currentUser']),
    wentWellToShow: function() {
      return this.wentWell.orderBy('rate', 'desc');
    }
  },
  // firestore () {
  //   return {
  //     retro,
  //     wentWell: retro.collection('wentWell'),
  //     toImprove: retro.collection('toImprove'),
  //     actionItems: retro.collection('actionItems'),
  //   }
  // },
  methods: {
    addTalkingPoint: function(collection, field) {
      if (this[field].trim() === '') return;
      retrosCollection
        .doc(this.retroID)
        .collection(collection)
        .add({
          title: this[field],
          rate: 1
        })
        .then(entry => {
          this[field] = '';
          if (collection !== 'actionItems') {
            this.voted[collection].push(entry.id);
            this.updateVotedLocalStorage();
          }
        });
    },
    pointOnBlur(collection, title, id, $event) {
      if (title === '') {
        retrosCollection
          .doc(this.retroID)
          .collection(collection)
          .doc(id)
          .delete();
      } else {
        retrosCollection
          .doc(this.retroID)
          .collection(collection)
          .doc(id)
          .update({
            title: title
          });
      }
      $event.target.blur();
    },
    voteClick(collection, id) {
      if (this.checkIsVoted(collection, id)) {
        retrosCollection
          .doc(this.retroID)
          .collection(collection)
          .doc(id)
          .update('rate', firebase.firestore.FieldValue.increment(-1));
        if (collection !== 'actionItems') {
          this.cleanLocalStorage(collection, [id]);
        }
      } else {
        retrosCollection
          .doc(this.retroID)
          .collection(collection)
          .doc(id)
          .update('rate', firebase.firestore.FieldValue.increment(1));
        if (!this.voted[collection]) {
          this.voted[collection] = [];
        }
        this.voted[collection].push(id);
        this.updateVotedLocalStorage();
      }
    },
    clipboardSuccessHandler() {
      this.copyButtonText = 'Link Copied';
      this.copyButtonActiveClass = 'copyButtonActive';

      setTimeout(() => {
        this.copyButtonText = 'Copy Link';
        this.copyButtonActiveClass = '';
      }, 1000);
    },
    checkIsVoted(collection, id) {
      return this.voted && this.voted[collection] && this.voted[collection].indexOf(id) !== -1;
    },
    updateVotedLocalStorage() {
      localStorage['voted_' + this.retroID] = JSON.stringify(this.voted);
    },
    saveRetroTitle(event) {
      retrosCollection
        .doc(this.retroID)
        .update({
          retroName: event.target.value
        })
        .then(() => {
          event.target.blur();
          this.updatePageTitle();
        });
    },
    updatePageTitle() {
      document.title = this.retro.retroName.trim() ? `${this.retro.retroName} - EZ Retro` : 'EZ Retro';
    },
    cleanLocalStorage(collection, needToDeleteItem) {
      if (this.voted[collection]) {
        const cleaned = this[collection].map(item => item.id);
        this.voted[collection] = this.voted[collection].filter(one => {
          return cleaned.indexOf(one) !== -1 && needToDeleteItem.indexOf(one) === -1;
        });
        this.updateVotedLocalStorage();
      }
    },
    closePrompt() {
      sessionStorage.promptShowed = '1';
      this.showPrompt = false;
    }
  },
  mounted() {
    const retro = retrosCollection.doc(this.retroID);

    if (localStorage['voted_' + this.retroID]) {
      this.voted = JSON.parse(localStorage['voted_' + this.retroID]);
    }

    const wentWellPromise = this.$bind('wentWell', retro.collection('wentWell').orderBy('rate', 'desc'));
    const toImprovePromise = this.$bind('toImprove', retro.collection('toImprove').orderBy('rate', 'desc'));

    this.$bind('actionItems', retro.collection('actionItems'));
    if(this.retro && this.retro.retroName){
      this.$bind('retro', retro).then(() => {
        this.updatePageTitle();
      });
    }
    this.showPrompt = !sessionStorage.promptShowed && !this.currentUser
    ANALYTICS.logEvent('page_view');
  }
};
</script>

<style scoped></style>
